<template>
  <FirstAccessContent class="mt-24" />
  <Changelog />
</template>

<script setup>
import FirstAccessContent from '@organisms/FirstAccessContent/FirstAccessContent.vue'
import Changelog from '@organisms/Changelog/Changelog.vue'
</script>
